// Una exportacion a la vez: el dialogo solo sigue la que acaba de pedir el usuario.
const initialState = () => ({
  jobId: null,
  // queued | running | succeeded | failed — los mismos valores que persiste el backend
  status: null,
  downloadUrl: null,
  // Codigo estable del backend; el texto lo decide la UI
  errorCode: null,
  retryAfterSeconds: null,
  isStarting: false
})

export default initialState
